import { createExperiments } from '@cbhq/experiments';

const experimentConfig = {
  /* eslint-disable camelcase */
  // long-running feature flags
  sep_2023_cloud_staking_api_allowlist: ['control', 'treatment'] as const,
  nov_2023_legacy_api_management: ['control', 'treatment'] as const,
  mar_2024_participate_allowlist: ['control', 'treatment'] as const,

  // pre-launch feature flags
  may_2024_boat: ['control', 'treatment'] as const,
  may_2024_wallet_history: ['control', 'treatment'] as const,
  jun_2024_edwards_api_key: ['control', 'treatment'] as const,
  jun_2024_pay_with_crypto: ['control', 'treatment'] as const,
  jul_2024_paymaster_analytics: ['control', 'treatment'] as const,
  jul_2024_paymaster_analytics_percent: ['control', 'treatment'] as const,
  jul_2024_webhooks: ['control', 'treatment'] as const,
  jul_2024_paymaster_guide: ['control', 'treatment'] as const,
  aug_2024_paymaster_erc20: ['control', 'treatment'] as const,
  oct_2024_project_teams_endpoint: ['control', 'treatment'] as const,
  nov_2024_build_quest: ['control', 'treatment'] as const,
  nov_2024_smart_contracts: ['control', 'treatment'] as const,
  nov_2024_base_l3: ['control', 'treatment'] as const,
  /* eslint-enable camelcase */
};

export const Experiments = createExperiments(experimentConfig);
